import { t } from '@if/core/i18n'
import {
  EApplicantType,
  ECreditApplicationStep,
  ETasksStatus,
  ETaskType,
  getEApplicantTypeList,
  getECreditApplicationStepList,
  getETasksStatusList,
} from '@if/core/types'
import * as yup from '@if/core/yup'

export const creditTaskCommentSchema = yup.object({
  id: yup.string().default(null).nullable(),
  taskId: yup.string().default(null).nullable(),
  creditApplicationId: yup.string().default(null).nullable(),
  financingProgramId: yup.string(),
  value: yup.string().required().default(''),
  createdOn: yup.date(),
  createdByUserId: yup.string().default(null).nullable(),
  createdByUserFullname: yup.string(),
  updatedByUserFullname: yup.string(),
  updatedByUserId: yup.string().default(null).nullable(),
  updatedOn: yup.date(),
})

export const creditTaskSchema = yup.object({
  id: yup.string().default(null).nullable(), // le default null est nécessaire pour le createEntityAdapter
  creditApplicationId: yup.string(),
  financingProgramId: yup.string(),
  typeId: yup.mixed<ETaskType>().required('numberRequired'), // on pourrait mettre la liste complète des types ici, mais ca serait overkill puisqu'on la recoit du serveur
  status: yup.mixed<ETasksStatus>().default(ETasksStatus.ToDo).oneOf(getETasksStatusList()),
  description: yup.string().nullable().default(''),
  applicantType: yup
    .mixed<EApplicantType>()
    .nullable()
    .oneOf([...getEApplicantTypeList(), null]),
  comments: yup.array(creditTaskCommentSchema).required().default([]),
  reminderOn: yup
    .date()
    .transform((_, val: Date | string | number | null | undefined) => {
      if (val === '' || val === null || val === undefined) return null
      return new Date(val)
    })
    .nullable()
    .default(null)
    .min(new Date(), () => t('common.errors.reminderDateFuture')),
  requiredBeforeStep: yup
    .mixed<ECreditApplicationStep>()
    .nullable()
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .transform((val) => (val === '' ? null : val))
    .default(null)
    .oneOf(getECreditApplicationStepList()),
  createdByUserId: yup.string(),
  versionTag: yup.string(),
  subKey: yup.string().nullable().default(''),
  labelSuffix: yup.string().nullable().default(''),
  subKey2: yup.string().nullable().default(''),
  labelSuffix2: yup.string().nullable().default(''),
})

export type CreditApplicationTask = yup.InferSubmit<typeof creditTaskSchema> & {
  updatedOn?: Date | null
  updatedByUserFullname?: string | null
  financingProgramId?: string | null
}
export type CreditTaskComment = yup.InferSubmit<typeof creditTaskCommentSchema>
